import Head from 'next/head';
import React from 'react';

const title = 'Cash Gifts & Funds for Weddings & Honeymoon Funds';
const description =
  'Add cash gifts and funds to your wedding registry. Give guests the option to gift you money to put towards your honeymoon, your wedding, a house or anything you and your partner desire!';

function CashGiftsHeader(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} key="og:title" />
      <meta property="og:description" content={description} key="og:description" />
      <link rel="canonical" href="https://www.zola.com/wedding-registry/how-cash-gifts-work" />
    </Head>
  );
}

export default CashGiftsHeader;
